import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full border-t border-brand-border/50 bg-[#06080c] py-12 px-6 relative z-10 mt-20">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center">
          <img 
            src="https://cloud-1de12d.becdn.net/media/original/3c6d7a4dcd546bac53585159bae233fe.png" 
            alt="R&R Logo" 
            className="h-8 opacity-80 hover:opacity-100 transition-opacity" 
          />
        </div>
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-gray-400">
          <a 
            href="https://rr.marketing/impressum" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors"
          >
            Impressum
          </a>
          <a 
            href="https://rr.marketing/datenschutz" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors"
          >
            Datenschutz
          </a>
        </div>
        <div className="text-xs text-gray-600">
          &copy; {new Date().getFullYear()} Revenue Native - Ein Angebot der R&R Marketing. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default Footer;